export default __webpack_public_path__ + "static/media/busd.0e760711.svg";